import styles from "./Facets.module.css";

const FacetsApplyButton = () => {
    return (
        <button type="submit" className={styles.submitFilters}>
            Apply filters
        </button>
    );
};

export default FacetsApplyButton;
